import { useContext } from 'react';
import { BreakpointsContext } from '../contexts/BreakpointsContext';

export default function useBreakpoints() {
  return useContext(BreakpointsContext);
}
